import { GetStaticProps } from 'next';
import React, { useEffect } from 'react';
import Internship from '../components/Internships';
import { MetaTagsComp } from '../components/MetaTagsComp';
import fetchUtil from '../utils/fetchUtil';


const Internships: React.FC = (props: any) => {
  const { meta } = props.pageData
  useEffect(() => {
    const customStyle = document.documentElement.style
    customStyle.setProperty('--navbar-color', '#6C48F0');
    customStyle.setProperty('--navbar-menu-color', '#ffff')
  }, [])
  return (
    <>
      {meta && <MetaTagsComp {...meta} />}
      <Internship {...props} />
    </>
  )
}

export const getStaticProps: GetStaticProps = async (context) => {
  const pageData = await fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/internships`, 'GET', {}, '', false)
  const intershipsData = await fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/country-internships?country=USA&_start=0&_limit=3`, 'GET', {}, '', false)
  return {
    props: { pageData, intershipsData }
  };
}

export default Internships;